// Method to calculate time difference percentage
const getTimeDifferencePercentage = (preparation_time, diff) => {
  const defaultPrepTimeInSec = preparation_time;
  const defaultPrepTimeInMS = defaultPrepTimeInSec * 1000;
  let totalTime = defaultPrepTimeInMS;
  let percentage = (diff / totalTime) * 100; // Calculate the percentage
  return percentage;
};

// Method to determine row color based on the time difference percentage
const getRowColor = (preparation_time, differenceInMs) => {
  if (!preparation_time) return "";
  let percentage = getTimeDifferencePercentage(
    preparation_time,
    differenceInMs
  );
  if (percentage > 100) {
    return "item-percent-hundred"; // More than 100% -> Red error darken-1
  } else if (percentage > 80) {
    return "item-percent-eighty"; // More than 80% -> Orange
  } else {
    return "";
  }
};

// TO SHOW ICON FOR PREP TIME
const isPrepTimeOver = (preparation_time, differenceInMs) => {
  if (!preparation_time) return false;
  let percentage = getTimeDifferencePercentage(
    preparation_time,
    differenceInMs
  );
  if (percentage > 80) {
    return true; 
  }else {
    return false;
  }
};

const GetPrepTimerColor = (preparation_time, differenceInMs) => {
  if (!preparation_time) return "";
  let percentage = getTimeDifferencePercentage(
    preparation_time,
    differenceInMs
  );
  if (percentage > 100) {
    return "item-percent-hundred2"; // More than 100% -> Red error darken-1
  } else if (percentage > 80) {
    return "item-percent-eighty2"; // More than 80% -> Orange
  } else {
    return "";
  }
};


export { getRowColor,isPrepTimeOver,GetPrepTimerColor };
